module.exports = __webpack_public_path__ + "img/25-explorer.98047861.png";